import { Component, EventEmitter, Output } from '@angular/core';
import { COMPONENT_NAME, EVENT_TYPE } from '@app/constants/message.constants';
import { MessageAction } from '@app/models/message-action.model';
import { MessageComponent } from '@app/models/message-base.component';

@Component({
  selector: 'app-new-conversation',
  templateUrl: './new-conversation.component.html',
  styleUrls: ['./new-conversation.component.scss']
})
export class NewConversationComponent extends MessageComponent {
  @Output() onMessageAction = new EventEmitter<MessageAction>();
  override type = COMPONENT_NAME.NEW_CONVERSATION;

  onNewConversation() {
    this.enabledButtons = false;
    this.onMessageAction.emit({ type: EVENT_TYPE.SHOULD_START_NEW_CONVERSATION, value: true });
  }
}


